import * as React from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';

import {
	CerebroPageContainer,
	CerebroBreadcrumb,
	CerebroHeading,
	CerebroText,
	CerebroPrimaryButton,
	CerebroSummary,
} from '../shared/components';
import { Urls, useApi } from '../shared/context';
import { Deal } from '../shared/models';
import { QueryKeys, useDealQuery } from '../shared/hooks';
import { CerebroApiEndpoints } from '../shared/utils/api';
import { useAuth } from '../shared/context';
import { getApiResponseData } from '../shared/utils/axios';

export const Review: React.FC = () => {
	const snackbar = useSnackbar();

	const api = useApi();
	const auth = useAuth();

	const navigate = useNavigate();

	const { guid } = useParams<'guid'>();
	const client = useQueryClient();

	const dealQuery = useDealQuery(guid);

	const isReviewPageActive = dealQuery.data?.dealStatus === 'Started';

	const summaryMutation = useMutation(
		async () => {
			const { data, error } = await getApiResponseData<Deal>(
				api.patch(CerebroApiEndpoints.Deals.Root(guid), { dealStatus: 'ReadyForReview', sourcePage: 'Review' })
			);

			if (error) {
				throw new Error(error.response?.data);
			}

			return data;
		},
		{
			onSuccess: deal => {
				client.setQueryData(QueryKeys.Deal.Root(guid), deal);
				snackbar.enqueueSnackbar('Progress Saved.', { variant: 'success' });
				navigate(`/${guid}/${Urls.Results.Root}`);
			},
			onError: (error: Error) => {
				snackbar.enqueueSnackbar(error.message, {
					variant: 'error',
				});
			},
		}
	);

	return (
		<CerebroPageContainer>
			<CerebroBreadcrumb>Review</CerebroBreadcrumb>
			<CerebroHeading>Review &amp; Submit</CerebroHeading>

			{!auth.currentUser?.isEmployeeUser && !isReviewPageActive ? (
				<>
					<CerebroText sx={{ marginTop: 3, marginBottom: 6 }}>
						Your loan application has been submitted. Please continue to see the results.
					</CerebroText>

					<CerebroPrimaryButton
						onClick={() => navigate(`/${guid}/${Urls.Results.Root}`)}
						sx={{ marginBottom: 6 }}
					>
						Continue To Results
					</CerebroPrimaryButton>
				</>
			) : (
				<>
					<CerebroText sx={{ marginTop: 3, marginBottom: 6 }}>
						Submit your loan application for review by Cerebro expert who will determine the best process
						for getting you the capital you need.
					</CerebroText>

					<CerebroPrimaryButton onClick={() => summaryMutation.mutate()} sx={{ marginBottom: 6 }}>
						Submit Loan Application
					</CerebroPrimaryButton>

					<CerebroSummary showLinks={true} compressView={false} />

					<CerebroPrimaryButton onClick={() => summaryMutation.mutate()} sx={{ marginTop: 6 }}>
						Submit Loan Application
					</CerebroPrimaryButton>
				</>
			)}
		</CerebroPageContainer>
	);
};
